import { AxiosResponse } from "axios";
import axiosApiInstance from "./axiosInstance.api";
import axiosApiInstanceNoToken from "./axiosInstanceNoToken";

const responseBody = (response: AxiosResponse) => response.data;

const axiosTokenRequests = {
  get: (url: string) => axiosApiInstance.get(url).then(responseBody),
  post: (url: string, body: {}) =>
    axiosApiInstance.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    axiosApiInstance.put(url, body).then(responseBody),
  del: (url: string) => axiosApiInstance.delete(url).then(responseBody),
};

const axiosNoTokenRequests = {
  get: (url: string) => axiosApiInstanceNoToken.get(url).then(responseBody),
  post: (url: string, body: {}) =>
    axiosApiInstanceNoToken.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    axiosApiInstanceNoToken.put(url, body).then(responseBody),
  del: (url: string) => axiosApiInstanceNoToken.delete(url).then(responseBody),
};

export { axiosTokenRequests, axiosNoTokenRequests };
